import(/* webpackMode: "eager" */ "/home/tsc/microservice/tpay_this/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsc/microservice/tpay_this/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsc/microservice/tpay_this/components/Header.tsx");
